export default __webpack_public_path__ + "static/media/pool_white.a187c942.svg";